const SearchEmptyState = ({
    message,
    padding = '24px 20px 32px',
}) => {
    return (
        <div style={{ padding }}>
            <div style={{
                padding: '18px 16px',
                borderRadius: '14px',
                border: '1px solid var(--app-separator)',
                background: 'var(--app-surface)',
                color: 'var(--app-text-secondary)',
                fontSize: '14px',
                fontWeight: '500',
                textAlign: 'center',
            }}>
                {message}
            </div>
        </div>
    );
};

export default SearchEmptyState;
